import { shallowEqual, useSelector } from 'react-redux'

export const useUserJivoCode = () => {
  const value: string | null = useSelector(
    (state: any) => state.user.jivo_code || null,
    shallowEqual,
  )
  return value
}
